export default "__VITE_ASSET__Cy5j2mb3__"